import {CloseDayResponseModel, ValidationErrorModel} from "../../models";
import {getUserId, getUserStationId} from "../secure/secureManager";
import {SystemConfiguration} from "../../configuration";
import {secureLocalStorageSet} from "../localStorage/localStorageManager";
import {saveStationCloseDay} from "../../serviceBroker/closeDayApiServiceBroker";
import {logoutServerUser} from "../../serviceBroker/userApiServiceBroker";

export const logoutUserFromServer  = async (
    userId: number
): Promise<{
    success: boolean;
    errors?: any[];
    data?: any;
}> => {
    try {
        const data = await logoutServerUser(userId);

        if (data?.Errors?.length || !data?.Result) {
            return {
                success: false,
                errors: data?.Errors,
                data
            };
        }
        return { success: true, data };
    } catch (error) {
        console.error("Logout error:", error);
        return {
            success: false,
            errors: [{ MessageEn: "Logout failed", MessageAr: "فشل تسجيل الخروج" }]
        };
    }
};

export const submitCloseDayRequest  = async (
    request: CloseDayResponseModel
): Promise<{
    success: boolean;
    errors?: ValidationErrorModel[];
    isCurrentUser?: boolean;
    data?: any;
}> => {
    try {
        const res: any = await saveStationCloseDay(request);

        // Check for errors in response
        if (
            res !== null &&
            res !== undefined &&
            res.Errors !== null &&
            res.Errors !== undefined &&
            res.Errors.length !== 0
        ) {
            return {
                success: false,
                errors: res.Errors
            };
        }

        // Check if operation is for current user
        const currentUserId = getUserId();
        const isCurrentUser = request.operationUserId === currentUserId;

        // Set flag for force logout after print (only for current user)
        if (isCurrentUser) {
            secureLocalStorageSet(
                SystemConfiguration.miscellaneous_Configurations.forceLogoutAfterPrint,
                "true"
            );
        }

        return {
            success: true,
            isCurrentUser,
            data: res,
        };
    } catch (err: any) {
        const errors: ValidationErrorModel[] = [
            {
                MessageAr: err?.message || err.toString(),
                MessageEn: err?.message || err.toString()
            },
        ];
        return {
            success: false,
            errors
        };
    }
};

export const prepareCloseDayRequest = (
    values: Partial<CloseDayResponseModel>,
): CloseDayResponseModel => {
    return {
        ...values,
        stationId: getUserStationId(),
        operationUserId: getUserId(),
    } as CloseDayResponseModel;
};
export const getLogoutRedirectUrl = (): string => {
    return SystemConfiguration.others_Configurations.logoutRedirectUrl;
};
export const clearForceLogoutFlag = (): void => {
    secureLocalStorageSet(
        SystemConfiguration.miscellaneous_Configurations.forceLogoutAfterPrint,
        "false"
    );
};